/*
 * @Author: 麦勇潮
 * @Date: 2020-11-26 12:54:44
 * @LastEditors: 麦勇潮
 * @LastEditTime: 2021-01-12 15:29:02
 */
import originJSONP from 'jsonp'

export default function jsonp (url, data, option) {
  url += (url.indexOf('?') < 0 ? '?' : '&') + param(data)
  // console.log(url)
  return new Promise((resolve, reject) => {
    originJSONP(url, option, (err, data) => {
      if (!err) {
        resolve(data)
      } else {
        reject(err)
      }
    })
  })
}

function param (data) {
  let url = ''
  for (var k in data) {
    let value = data[k] !== undefined ? data[k] : ''
    url += `&${k}=${encodeURIComponent(value)}`
  }
  return url ? url.substring(1) : ''
}



// WEBPACK FOOTER //
// ./src/common/jsonp.js